import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserLoginService } from '../userlogin.service';
import { Router } from '@angular/router';
import { interval, Subscription } from 'rxjs';
import { takeWhile } from 'rxjs/operators';

@Component({
  selector: 'app-school-signup',
  templateUrl: './school-signup.component.html',
  styleUrls: ['./school-signup.component.css']
})
export class SchoolSignupComponent implements OnInit {
  signupForm: FormGroup;
  selectedRole: string = 'Student';
  otpSent: boolean = false;
  otpVerified: boolean = false;
  otpTimer: number = 60;
  timerSubscription?: Subscription;

  roles = [
    { id: 'Student', icon: 'fas fa-user-graduate',      label: 'Student',  description: 'Access your timetable, results, and fee records.' },
    { id: 'Teacher', icon: 'fas fa-chalkboard-teacher', label: 'Teacher',  description: 'Manage classes, attendance, and assignments.' },
    { id: 'Staff',   icon: 'fas fa-user-tie',           label: 'Staff',    description: 'Handle admissions and administrative tasks.' }
  ];

  constructor(
    private fb: FormBuilder,
    private userLoginService: UserLoginService,
    private router: Router
  ) {
    this.signupForm = this.fb.group({
      role: ['Student', Validators.required],

      // Personal Details
      firstName:    ['', Validators.required],
      lastName:     ['', Validators.required],
      email:        ['', [Validators.required, Validators.email]],
      mobileNumber: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],

      // Professional Details (Conditional)
      specialization: [''],
      employeeId:     [''],
      licenseNumber:  [''],

      // Account Security
      username:        ['', Validators.required],
      password:        ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', Validators.required],
      otp: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]]
    }, { validator: this.passwordMatchValidator });
  }

  ngOnInit(): void {}

  passwordMatchValidator(g: FormGroup) {
    return g.get('password')?.value === g.get('confirmPassword')?.value
      ? null
      : { mismatch: true };
  }

  selectRole(roleId: string) {
    this.selectedRole = roleId;
    this.signupForm.patchValue({ role: roleId });

    if (roleId === 'Teacher') {
      this.signupForm.get('specialization')?.setValidators([Validators.required]);
      this.signupForm.get('licenseNumber')?.setValidators([Validators.required]);
    } else {
      this.signupForm.get('specialization')?.clearValidators();
      this.signupForm.get('licenseNumber')?.clearValidators();
    }
    this.signupForm.get('specialization')?.updateValueAndValidity();
    this.signupForm.get('licenseNumber')?.updateValueAndValidity();
  }

  sendOtp() {
    if (this.signupForm.get('mobileNumber')?.valid) {
      this.otpSent = true;
      this.startTimer();
    }
  }

  startTimer() {
    this.otpTimer = 60;
    this.timerSubscription?.unsubscribe();
    this.timerSubscription = interval(1000)
      .pipe(takeWhile(() => this.otpTimer > 0))
      .subscribe(() => { this.otpTimer--; });
  }

  onSubmit() {
    if (this.signupForm.valid) {
      this.userLoginService.UserLogin_Create(this.signupForm.value as any).subscribe(
        (res: any) => { this.router.navigate(['/login']); },
        (err: any) => { console.error('Registration failed', err); }
      );
    } else {
      this.markFormGroupTouched(this.signupForm);
    }
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if ((control as any).controls) {
        this.markFormGroupTouched(control as FormGroup);
      }
    });
  }
}